<template>

  <div>
    <!-- 添加弹出框 -->
    <el-dialog :visible.sync="show" width="70%" top="2vh" :close-on-click-modal="false">

      <div style="height: 72vh ;overflow-y: auto;">

        <el-form :model="submit_data" ref="myForm" label-width="70px">

          <el-form-item label="导航列表：" label-width="90px">

            <el-checkbox-group v-model="array" v-for="(v,k) in check_lists">

              <!-- 一级菜单 -->
              <el-checkbox :label="v.index" :ref="v.index" :data="v" v-if="v.title" @change="checkChange(v.index,'1')">

                {{v.title}}


              </el-checkbox>

              <el-form-item></el-form-item>


              <el-checkbox-group v-model="array" v-for="(v1,k1) in v.subs" style="margin-left: 2%;margin-top: -1%;">

                <!-- 二级菜单 -->
                <el-checkbox :label="v1.index" :ref="v1.index" :data="v1" v-if="v1.title"
                  @change="checkChange(v1.index,'2',v.index)">

                  {{v1.title}}


                </el-checkbox>

                <el-form-item></el-form-item>


                <el-checkbox-group v-model="array" style="margin-left: 2%;margin-top: -1%;">



                  <!-- 三级菜单 -->
                  <el-checkbox v-for="(v2,k2) in v1.subs" :label="v2.index" :ref="v2.index" :data="v2" v-if="v2.title"
                    @change="checkChange(v2.index,'3',v.index,v1.index)">

                    {{v2.title}}


                  </el-checkbox>




                  <el-form-item></el-form-item>

                </el-checkbox-group>


              </el-checkbox-group>



            </el-checkbox-group>



          </el-form-item>

        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="editMenuSubmit">确定</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
  var _this;
  export default {
    created() {

      _this = this;

    },


    // 接受父组件传的值
    props: {

      isShow: true,
      data: ''

    },
    // 监听父组件传过来的值
    watch: {

      isShow(newData, oldData) {
        _this.submit_data.admin_role_code = _this.data;

        _this.getAllMenu();



        _this.show = true;

      }

    },
    data() {

      return {
        array: [],
        show: false,
        search_data: {},
        check_lists: {},

        submit_data: {

          admin_role_code: '',
          menu: '',

        },


      }
    },
    methods: {

      arrayDel(data) {
        for (let delindex = 0; delindex < _this.array.length; delindex++) {

          // 如果数组中存在需要删除的数据则删除
          if (_this.array[delindex] == data) {
            _this.array.splice(delindex, 1);
          }

        }
      },

      checkChange(e, level, firParent, secParent) {

        console.log(_this.array);

        switch (level) {
          case '1':


            // 如果点击的一级元素被选中
            if (!(_this.$refs[e][0].isChecked)) {


              if (_this.$refs[e][0].$attrs.data.subs) {

                // 将对应的二级选中
                for (let i = 0; i < _this.$refs[e][0].$attrs.data.subs.length; i++) {

                  _this.array.push(_this.$refs[e][0].$attrs.data.subs[i].index)


                  // 数组去重
                  _this.array = [...new Set(_this.array)];



                  if (_this.$refs[e][0].$attrs.data.subs[i].subs) {

                    // 将对应的三级选中
                    for (let j = 0; j < _this.$refs[e][0].$attrs.data.subs[i].subs.length; j++) {

                      _this.array.push(_this.$refs[e][0].$attrs.data.subs[i].subs[j].index)

                      // 数组去重
                      _this.array = [...new Set(_this.array)];
                    }

                  }

                }

              }

              console.log(_this.array);

            } else {

              if (_this.$refs[e][0].$attrs.data.subs) {

                // 遍历得到二级pass_action属性
                for (let i = 0; i < _this.$refs[e][0].$attrs.data.subs.length; i++) {

                  // 需要在array中删除的数据
                  var delData2 = _this.$refs[e][0].$attrs.data.subs[i].index;

                  _this.arrayDel(delData2);

                  if (_this.$refs[e][0].$attrs.data.subs[i].subs) {

                    // 遍历得到三级pass_action属性
                    for (let j = 0; j < _this.$refs[e][0].$attrs.data.subs[i].subs.length; j++) {

                      var delData3 = _this.$refs[e][0].$attrs.data.subs[i].subs[j].index;

                      _this.arrayDel(delData3);

                    }

                  }

                }

              }

            }

            break;
          case '2':

            // 如果点击的二级元素被选中
            if (!(_this.$refs[e][0].isChecked)) {

              if (_this.$refs[e][0].$attrs.data.subs) {

                // 将对应的三级选中
                for (let i = 0; i < _this.$refs[e][0].$attrs.data.subs.length; i++) {

                  _this.array.push(_this.$refs[e][0].$attrs.data.subs[i].index)

                  // 数组去重
                  _this.array = [...new Set(_this.array)];

                }



              }



              // 将对应的一级选中
              _this.array.push(firParent);

              // 数组去重
              _this.array = [...new Set(_this.array)];

            } else {

              if (_this.$refs[e][0].$attrs.data.subs) {


                // 遍历得到三级pass_action属性
                for (let i = 0; i < _this.$refs[e][0].$attrs.data.subs.length; i++) {

                  // 需要在array中删除的数据
                  var delData3 = _this.$refs[e][0].$attrs.data.subs[i].index;

                  _this.arrayDel(delData3);

                }

              }



            }

            break;
          case '3':



            // 如果点击的三级元素被选中
            if (!(_this.$refs[e][0].isChecked)) {

              // 将对应的一级选中
              _this.array.push(firParent);

              // 数组去重
              _this.array = [...new Set(_this.array)];

              // 将对应的二级选中
              _this.array.push(secParent);

              // 数组去重
              _this.array = [...new Set(_this.array)];

            }



            break;
          default:
            break;
        }


      },


      //初始化权限列表
      getAllMenu() {

        _this.$post(
          "/system/getMenuDetails", {
            admin_role_code: _this.submit_data.admin_role_code
          }
        ).then(res => {


          _this.check_lists = res.data;
          console.log(res.data[0]);


            for (let i = 0; i < res.data.length; i++) {

              if (res.data[i].checked) {
                _this.array.push(res.data[i].index)

                if (res.data[i].subs) {

                  for (let j = 0; j < res.data[i].subs.length; j++) {

                    if (res.data[i].subs[j].checked) {
                      _this.array.push(res.data[i].subs[j].index)
                      console.log(_this.array,'_this.array');
                    }

                    if (res.data[i].subs[j].subs) {

                      for (let k = 0; k < res.data[i].subs[j].subs.length; k++) {

                        if (res.data[i].subs[j].subs[k].checked) {
                          _this.array.push(res.data[i].subs[j].subs[k].index)
                        }

                      }

                    }


                  }

                }



              }



            }



          console.log(_this.check_lists);

        }).catch((err) => {

        })


      },
      cancel() {
        _this.show = false;
        _this.clear();
      },
      clear() {

        _this.submit_data = {

          admin_role_code: '',
          menu: '',

        }

        _this.array = [];
      },


      editMenuSubmit() {

        //json格式化
        _this.submit_data.menu = JSON.stringify(_this.array);


        console.log(_this.submit_data.menu,' _this.submit_data.menu');
        console.log(_this.array,' _this.array');


        _this.$post(
          "/system/editMenuSubmit",
          _this.submit_data
        ).then(res => {

          //弹出显示成功
          _this.$message.success(res.msg);

          _this.clear();

          // 关闭添加弹窗
          _this.show = false;

          // 初始化页面
          var return_data = {
            page: 1,
            limit: 10,
            name: ''
          };


          _this.$emit("submit_ok_return", return_data);


        })

        _this.array = [];
      }
    }
  }
</script>
<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 300px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }


  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .formName {
    margin-left: 20px;
  }
</style>
